import { IState } from 'shared/store';

export const selectIsPerformanceVasPilot = (state: IState): boolean => !!state.rs.isPerformanceVasPilot;
